import React, {useEffect, useState} from 'react'
import {KTIcon} from '../../../../_metronic/helpers'
import {IBillingRequest} from '../../../../coreGlobal/models/billing'
import {formatMonetaryToBr, removeMask} from '../../../../utils/formatMonetaryToBr'
import {PaymentConfig} from '../../../../components/PaymentConfig/PaymentConfig'
import Swal from 'sweetalert2'
import {usePaymentConfig} from '../../../../components/PaymentConfig/core/PaymentConfigProvider'
import {updatePayment} from '../core/_requests'

interface IChangePaymentModal {
  id: number
  billings: Array<IBillingRequest>
  close: () => void
}
export const ChangePaymentModal = ({id, billings, close}: IChangePaymentModal) => {
  const {payment} = usePaymentConfig()
  const [authorizePaymentChange, setAuthorizePaymentChange] = useState<boolean>(true)
  const [selectedBillings, setSelectedBillings] = useState<number[]>([])
  const [totalPayable, setTotalPayable] = useState<number>(0)

  const allSelected = billings.length > 0 && selectedBillings.length === billings.length
  const toogleSelectAll = () => {
    if (allSelected) {
      setSelectedBillings([])
      setTotalPayable(0)
    } else {
      setSelectedBillings(billings.map((item) => item.id))
      setTotalPayable(billings.reduce((acc, item) => acc + Number(item.amount), 0))
    }
  }

  const handleCheckboxChange = (e, item) => {
    const isChecked = e.target.checked
    const amount = Number(item.amount)

    if (isChecked) {
      setSelectedBillings((value) => [...value, item.id])
      setTotalPayable(totalPayable + amount)
    } else {
      setSelectedBillings((prevValue) => prevValue.filter((id) => id !== item.id))
      setTotalPayable(totalPayable - amount)
    }
  }

  useEffect(() => {
    let totalPayment = payment?.reduce((previousValue, currentValue) => {
      return Number(previousValue) + Number(removeMask(String(currentValue.value)))
    }, 0)

    setAuthorizePaymentChange(Number(totalPayment).toFixed(2) === Number(totalPayable).toFixed(2))
  }, [payment])

  const changePayment = async () => {
    Swal.fire({
      title: 'Deseja atualizar a forma de pagamento?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-secondary',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          Swal.fire({
            position: 'center',
            icon: 'info',
            title: 'Salvando...',
            showConfirmButton: false,
            allowOutsideClick: false,
          })

          const newBillings = payment.map((item) => {
            const {value, paymentRef, numberOfInstallments, ...rest} = item
            return {
              ...rest,
              amount: removeMask(value),
              installments: numberOfInstallments > 0 ? numberOfInstallments : 1,
            }
          })
          const data = {
            billings: selectedBillings,
            newBillings: newBillings,
          }
          await updatePayment(id, data)

          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Sucesso!!!',
            text: 'Atualizado a forma de pagamento!',
            showConfirmButton: true,
            allowOutsideClick: false,
            customClass: {
              confirmButton: 'btn btn-danger',
              cancelButton: 'btn btn-secondary',
            },
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload()
            }
          })
        } catch (error: any) {
          if (error.response.status === 422) {
            let errorText = ''
            for (let key in error.response.data.errors) {
              errorText += '<li>' + error.response.data.errors[key][0] + '</li>'
            }
            await Swal.fire({
              icon: 'error',
              title: 'Ops! Revise seu formulário e tente novamente!',
              html: errorText,
              customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-secondary',
              },
            })
          } else {
            await Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.message,
              customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-secondary',
              },
            })
          }
        }
      }
    })
  }
  return (
    <>
      <div className='modal fade show d-flex' id='kt_modal_change_Payment'>
        <div className='modal-dialog modal-dialog-centered' style={{minWidth: '80%'}}>
          <div className='modal-content'>
            <div className='modal-header'>
              <h2 className='modal-title'>Alterar Forma de Pagamento</h2>
              <div
                className='btn btn-icon btn-sm btn-active-icon-danger'
                data-kt-users-modal-action='close'
                onClick={() => close()}
                style={{cursor: 'pointer'}}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </div>
            </div>
            <div className='modal-body'>
              <div className='table-responsive'>
                <table
                  className='table table-bordered table-hover table-row-bordered table-row-gray-100'
                  style={{tableLayout: 'fixed', width: '100%'}}
                >
                  <thead>
                    <tr className='fw-bold text-muted text-center'>
                      <th className='w-40px'>
                        <div className='form-check form-check-sm form-check-custom form-check-solid'>
                          <input
                            className='form-check-input widget-13-check'
                            type='checkbox'
                            checked={allSelected}
                            onChange={toogleSelectAll}
                          />
                        </div>
                      </th>
                      <th>Forma de pagamento</th>
                      <th>Parcelas</th>
                      <th>Preço</th>
                    </tr>
                  </thead>
                  <tbody>
                    {billings?.map((item) => (
                      <React.Fragment key={item.id}>
                        {item.status === 'Pendente' && (
                          <tr key={`tableChangePaymentModal${item.id}`}>
                            <td>
                              <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                <input
                                  className='form-check-input widget-13-check'
                                  type='checkbox'
                                  value={item.id}
                                  checked={selectedBillings.includes(item.id)}
                                  onChange={(e) => handleCheckboxChange(e, item)}
                                />
                              </div>
                            </td>
                            <td>{item.paymentOption?.name}</td>
                            <td>{item?.numberOfInstallments}</td>
                            <td>{formatMonetaryToBr(item?.amount)}</td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
              {totalPayable > 0 && (
                <PaymentConfig totalPayable={totalPayable} />
              )}
            </div>
            {totalPayable > 0 && (
              <div className='modal-footer d-flex justify-content-between w-100'>
                <button onClick={() => close()} type='button' className='btn btn-secondary '>
                  Cancelar
                </button>
                <button
                  disabled={!authorizePaymentChange}
                  type='button'
                  className='btn btn-danger'
                  onClick={() => changePayment()}
                >
                  Alterar Cobrança
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}
